<!--begin::Subheader-->
<div class="subheader py-2 py-lg-12" [ngClass]="subheaderCSSClasses" id="kt_subheader" *ngIf='(title$ | async) || (description$ | async)'>
  <div [ngClass]="subheaderContainerCSSClasses"
    class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
    <!--begin::Info-->
    <div class="d-flex align-items-center flex-wrap mr-1">
      <ng-container *ngIf="subheaderMobileToggle">
        <!--begin::Mobile Toggle-->
        <button class="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none" id="kt_subheader_mobile_toggle">
          <span></span>
        </button>
        <!--end::Mobile Toggle-->
      </ng-container>

      <!--begin::Page Heading-->
      <div class="d-flex flex-column">
        <!--begin::Page Title-->
        <ng-container *ngIf="title$ | async as _title">
          <!-- When a real breadcrumb (more than 2 items) is shown, the title is desktop-only
               so mobile keeps just the breadcrumb; single-crumb pages keep their title everywhere. -->
          <h2 class="text-white font-weight-bold my-2 mr-5"
              [ngClass]="((breadcrumbs$ | async)?.length > 2) ? 'd-none d-md-block' : ''">
            {{ _title | abpLocalization }}
            <ng-container *ngIf="subheaderDisplayDesc">
              <ng-container *ngIf="description$ | async as _description">
                <small>{{ _description | abpLocalization }}</small>
              </ng-container>
            </ng-container>
          </h2>
        </ng-container>
        <!--end::Page Title-->
        <!--begin::Breadcrumb-->
        <!--
          Breadcrumb is shown only when it carries a real path (more than 2 items).
          With a single item it just duplicates the page title, so we hide it but keep
          the row's vertical space (invisible spacer) so the layout does not shift.
        -->
        <ng-container *ngIf="breadcrumbs$ | async as breadcrumbs">
          <div class="d-flex align-items-center font-weight-bold my-2">
            <ng-container *ngIf="breadcrumbs.length > 2; else breadcrumbSpacer">
              <ng-container *ngFor="let bc of breadcrumbs; let i = index">
                <span class="label label-dot label-sm bg-white opacity-75 mx-3" *ngIf="i > 0"></span>
                <a [routerLink]="bc.linkPath" routerLinkActive="active" [title]="bc.linkText | abpLocalization"
                  class="text-white text-hover-white opacity-75 hover-opacity-100 breadcrumb-item">
                  {{ bc.linkText | abpLocalization }}
                </a>
              </ng-container>
            </ng-container>
            <ng-template #breadcrumbSpacer>
              <span aria-hidden="true">&nbsp;</span>
            </ng-template>
          </div>
        </ng-container>
        <!--end::Breadcrumb-->
      </div>
      <!--end::Page Heading-->
    </div>
    <!--end::Info-->

  </div>
</div>
<!--end::Subheader-->
